<template>
	<div>
		<!-- <link rel="stylesheet" href="https://unpkg.com/fullpage.js/dist/fullpage.min.css"> -->
		<ul id="menu">
			<li v-for="(page,key) in pages" :data-menuanchor="key" :key="key"><a :href="'#'+key">{{key.toUpperCase()}}</a></li>
			<li>
				
			</li>
		</ul>
		<a href="https://hopuc.com/" target="_blank" rel="noopener" class="logo">
			<svg version="1.1" id="logo" x="0px" y="0px" viewBox="0 0 500 500" style="enable-background:new 0 0 500 500;">
			<g id="logo-ai" fill="#fff" fill-opacity=".9">
				<g id="LWPOLYLINE_8_">
					<polygon points="462.9,48.5 215.2,334.2 393,444.2"/>
				</g>
				<g id="LWPOLYLINE_7_">
					<polygon points="254.5,399.9 204.6,369 216.2,461.8"/>
				</g>
				<g id="LWPOLYLINE_6_">
					<polygon points="462.9,48.5 31.5,220.5 182.8,314.1"/>
				</g>
			</g>
			</svg>
		</a>
		<full-page ref="fullpage" :options="options" id="fullpage">
			<div class="section" v-for="(page,key) in pages" :key="key">
				<p class="title">{{page.title}}</p>
				<p class="subtitle">{{page.subtitle}}</p>
				<a class="button" :href="page.url">Learn More</a>
			</div>
		</full-page>
	</div>
</template>

<script>
	export default {
		name: 'Portfolio',
		data() {
			return {
				options: {
					licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
					// afterLoad: this.afterLoad,
					// afterLoad: function(anchorLink, index){},
					// scrollOverflow: true,//内容超过满屏后是否显示滚动条，true则显示滚动条
					scrollBar: false,//是否包含滚动条，默认为false,若为true浏览器自带滚动条出现
					menu: "#menu",//绑定菜单，设定的相关属性与anchors的值对应后，菜单可以控制滚动，默认为false
					navigation: true,//是否显示导航，默认为false
					// navigationPosition: 'right',//导航小圆点的位置
					// navigationTooltips: ['player', 'note', 'qrcode', 'video'],//导航小圆点的提示
					loopBottom: true,
					scrollingSpeed: 500,//设置滚动速度，单位毫秒，默认700
					// touchSensitivity: 15,//在移动设备中滑动页面的敏感性，默认为5最高100，越大越难滑动
					anchors: ['player', 'note', 'qrcode', 'video'],//anchors定义锚链接，默认为[]
					sectionsColor: [
						"#1b9",
						// "#4BBFC3", 
						// "#7BAABE",
						"#e90",
						// "#e54",
						"#09d",
						"#77c",
						"#fc0",
						"#1bcee6",
						"#ee1a59",
						"#2c3e4f",
						"#ba5be9",
						"#b4b8ab"
					]
				},
				pages: {
					player:{
						title: "Hopuc Player",
						subtitle: "Hopuc Player is HTML5 video player.",
						url: "https://player.hopuc.com"
					},
					note:{
						title: "Hopuc Note",
						subtitle: "A simple online notepad with PHP as the backend and no database required.",
						url: "https://note.hopuc.com"
					},
					qrcode:{
						title: "Hopuc QR Code",
						subtitle: "A chrome extension for Scan the QR code on the current web page and convert it to text content, or generate a QR code from the current web page address.",
						url: "https://qrcode.hopuc.com"
					},
					video:{
						title: "Hopuc Video",
						subtitle: "A free online video website without ads.",
						url: "https://v.hopuc.com"
					}
				},
			}
		},
		created:function(){
			// console.log(Object.keys(this.pages))
		}
	}
</script>

<style>
	@import "./assets/fullpage.css";

	* {
		-webkit-box-sizing: border-box;
		-moz-box-sizing: border-box;
		box-sizing: border-box
	}
	
	html,
	body {
		margin: 0;
	}
	
	a {
		text-decoration: none
	}

	.section {
		position: relative;
		padding: 0 5%;
		text-align: center;
	}

	.title {
		/* text-align: center; */
		color: #fff;
		font-size: 50px;
		margin: 12px 0;
	}

	.subtitle {
		color: #fff;
		font-size: 18px;
	}

	.button {
		font-weight: 300;
		color: #fff;
		font-size: 18px;
		line-height: 24px;
		border: solid 1px rgba(255, 255, 255, .6);
		border-radius: 6px;
		transition: all 0.1s ease-out;
		padding: 10px 18px;
		margin: 0 0.8em;
		display: inline-block;
		text-decoration: none;
	}

	.button:hover {
		color: #333;
		background: #fff;
	}
	
	#logo {
		position: fixed;
		top: 20px;
		left: 20px;
		color: #fff;
		font-weight: 700;
		z-index: 99;
		font-size: 1.9em;
		-webkit-font-smoothing: antialiased;
		-moz-font-smoothing: antialiased
	}

	#menu-line {
		position: absolute;
		bottom: -4px;
		left: 0;
		width: 159px;
		height: 2px;
		background: #fff
	}

	#menu {
		position: fixed;
		/* top: 20px; */
		right: 20px;
		z-index: 70;
		-webkit-font-smoothing: antialiased;
		-moz-font-smoothing: antialiased;
		letter-spacing: 1px;
		font-size: 1.1em
	}

	#menu li {
		display: inline-block;
		margin: 10px 0;
		position: relative
	}

	#menu a {
		color: #fff;
		padding: 0 1.1em 1.1em 1.1em
	}

	#menu li.active a:after {
		content: '';
		margin: 0 1.1em 0 1.1em;
		height: 2px;
		background: #fff;
		display: block;
		position: absolute;
		bottom: -6px;
		left: 0;
		right: 0;
		display: block
	}
	
	/* .actions {
		position: fixed;
		bottom: 2%;
		margin: 0 auto;
		z-index: 99;
		left: 0;
		right: 0;
		text-align: center
	}

	.actions li {
		display: inline-block;
		margin: .3em .3em
	}

	.actions-button {
		padding: .73em 1.47em;
		background: rgba(53, 73, 94, .47);
		border-radius: 5px;
		display: block;
		color: #fff
	}

	.logo i {
		vertical-align: middle;
		position: relative;
		top: 2px;
		display: inline-block;
		width: 38px;
		height: 14px;
		color: #fff;
		top: -4px;
		left: -2px;
		fill: #fff
	} */

	.logo svg {
		height: 40px;
	}
	
	@media screen and (max-width: 640px) {
		#menu{
			display: none;
		}
	}
	
</style>
